import {createResourcesProxy, waitForCSS} from '@parcel/runtime-rsc/rsc-helpers';
import {preinit} from 'react-dom';
preinit(parcelRequire.resolve("lBmtU"), {as: 'style', precedence: 'default'});
let promise = Promise.all([parcelRequire.load("iFlJw"), parcelRequire.load("9f8mp"), parcelRequire.load("k5MRs"), parcelRequire.load("9DQq0")]).then(() => {
  return Promise.all([waitForCSS("https://reactspectrum.blob.core.windows.net/reactspectrum/aae4f1a83d6ca9684a379b741645ce7e5df981c1/s2-docs/error.47113788.css")]);
}).then(() => {
let originalModule = parcelRequire("jFoC3");
let resources = <>
  <link rel="modulepreload" href={parcelRequire.resolve("iFlJw")} />
  <link rel="modulepreload" href={parcelRequire.resolve("9f8mp")} />
  <link rel="stylesheet" href={parcelRequire.resolve("lBmtU")} precedence="default" />
  <link rel="modulepreload" href={parcelRequire.resolve("k5MRs")} />
  <link rel="modulepreload" href={parcelRequire.resolve("9DQq0")} />
</>;
let res = createResourcesProxy(originalModule, false, resources );
  return res;
});
module.exports = promise;
